import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";

import LogoAnimationLoader from '../Loading/LogoAnimationLoader';

import AdminNewsletterService from '../../api/services/AdminNewsletterService';
import { downloadExcel } from 'react-export-table-to-excel';

const NewslettersList = () => {
    const tableRef = useRef(null);
    const [Error, setError] = useState('');
    const [isLoading, setisloading] = useState(true);
    const [NewslettersList, setNewslettersList] = useState([]);
    // const [currentPage, setCurrentPage] = useState(1);
    // const recordsPage = 50;
    // const lastIndex = currentPage * recordsPage;
    // const firstIndex = lastIndex - recordsPage;
    // const records = NewslettersList.slice(firstIndex, lastIndex);
    // const npage = Math.ceil(NewslettersList.length / recordsPage)
    // const number = [...Array(npage + 1).keys()].slice(1)
    const navigate = useNavigate();
    // function prePage() {
    //     if (currentPage !== 1) {
    //         setCurrentPage(currentPage - 1)
    //     }
    // }
    // function changeCPage(id) {
    //     setCurrentPage(id);
    // }
    // function nextPage() {
    //     if (currentPage !== npage) {
    //         setCurrentPage(currentPage + 1)
    //     }
    // }



    const getNewslettersList = async () => {

        try {

            let responseData = await AdminNewsletterService.index().json()
            setNewslettersList(responseData.data)
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            getNewslettersList();

        }
        else {
            navigate('/');
        }

    }, [])
    const handleDelete = async (e) => {

        try {


            let responseData = await AdminNewsletterService.destroy(e).json()
            if (responseData.status === true) {
                swal("Newsletters Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getNewslettersList();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }
    const handleCallback = () => {
        // Update the name in the component's state
        getNewslettersList()

    }
    const header = ["No.", "Type", "Name", "Email"]
    const getTableData = () => {
        const table = tableRef.current;
        const body = Array.from(table.querySelectorAll("tbody tr")).map((tr) =>
            Array.from(tr.querySelectorAll("td")).map((td) => td.innerText)
        );

        return { body };
    };
    function useDownloadExcel() {
        const { body } = getTableData();
        downloadExcel({
            fileName: "Newsletters List",
            sheet: "Newsletters",
            tablePayload: {
                header,
                body: body

            },
        });
    }
    const updateNewsletterstatus = async (e) => {
        e.preventDefault();
        let id = e.target.id
        try {
             
            let responseData = await AdminNewsletterService.updatenewsletter(id).json();
            if (responseData.status === true) {

                swal("Updated!!!").then((updatecheckstatus) => {
                    if (updatecheckstatus) {
                        getNewslettersList();
                        window.location.reload();
                    }
                })
            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    return (
        <>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Newsletters List</h4>
                                        
                                        <button onClick={useDownloadExcel} className="btn btn-primary btn-sm ms-1"> Export Excel </button>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0" ref={tableRef}>
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th >
                                                        <strong>No.</strong>
                                                    </th>
                                                    <th >
                                                        <strong>Checked</strong>
                                                    </th>
                                                    
                                                    <th >
                                                        <strong>Type</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Name</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Email</strong>
                                                    </th>
                                                    <th style={{ textAlign: 'left' }}><strong>Action</strong></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    NewslettersList.map((element, index) => {

                                                        return (
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <td>
                                                                    {index + 1}
                                                                </td>
                                                                  <td>
                                                                    {element.ischecked == 0 ? <span className="btn btn-success btn-sm ms-1">Checked</span> : 
                                                                    <span className="btn btn-danger btn-sm ms-1">Not Checked</span>}
                                                                    <Link id={element.id}  onClick={updateNewsletterstatus}> Change?</Link>
                                                                    </td>
                                                                  <td>
                                                                    {element.type}

                                                                </td>
                                                                <td>
                                                                    {element.first_name}

                                                                </td>

                                                                <td>{element.email}</td>


                                                                <td style={{ textAlign: 'center' }}>
                                                                    <div className="d-flex">
                                                                        <Link

                                                                            to={`/admin/newslettersupdate/${element.id}`}
                                                                            className="btn btn-primary shadow btn-xs sharp me-1"
                                                                        >
                                                                            <i className="fas fa-pencil-alt"></i>
                                                                        </Link>
                                                                        <Link
                                                                            onClick={() =>
                                                                                swal({
                                                                                    title: "Are you sure?",
                                                                                    text: "Once deleted, you will not be able to recover this data!",
                                                                                    icon: "warning",
                                                                                    buttons: true,
                                                                                    dangerMode: true,
                                                                                }).then((willDelete) => {
                                                                                    if (willDelete) {
                                                                                        (handleDelete(element.id));
                                                                                    }
                                                                                })
                                                                            }

                                                                            className="btn btn-danger shadow btn-xs sharp"
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>

                                        </table>
                                        {/* <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {NewslettersList.length < lastIndex ? NewslettersList.length : lastIndex}
                                                {" "}of {NewslettersList.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default NewslettersList;
